// App.jsx
import React from 'react';
import './App.css';

const App = () => {
  return (
    <div className="App">
      {/* Header */}
      <header className="header">
        <nav className="navbar">
          <div className="nav-brand">
            <h2>🏥 HealthCare Pharmacy</h2>
          </div>
          <ul className="nav-menu">
            <li><a href="#home">Home</a></li>
            <li><a href="#services">Services</a></li>
            <li><a href="#about">About</a></li>
            <li><a href="#contact">Contact</a></li>
          </ul>
          <button className="emergency-btn">Emergency: +91 88700 01377</button>
        </nav>
      </header>

      {/* Hero Section */}
      <section id="home" className="hero">
        <div className="hero-content">
          <div className="hero-text">
            <h1>Your Health, Our Priority</h1>
            <p>Trusted pharmacy services with experienced pharmacists and comprehensive medication management across Chennai and Bengaluru.</p>
            <div className="hero-buttons">
              <button className="btn-primary">Find Medicines</button>
              <button className="btn-secondary">Consult Pharmacist</button>
            </div>
          </div>
          <div className="hero-image">
            <div className="pharmacy-card">
              <div className="pharmacy-icon">💊</div>
              <h3>Trusted Pharmacy</h3>
              <p>Quality medicines & expert care</p>
            </div>
          </div>
        </div>
      </section>

      {/* Services Section */}
      <section id="services" className="services">
        <div className="container">
          <h2>Our Pharmacy Services</h2>
          <div className="services-grid">
            <div className="service-card">
              <div className="service-icon">💊</div>
              <h3>Prescription Medicines</h3>
              <p>Wide range of prescription medications with proper verification and counseling from certified pharmacists.</p>
            </div>
            <div className="service-card">
              <div className="service-icon">🩺</div>
              <h3>Health Consultations</h3>
              <p>Free health consultations and medication reviews with our experienced pharmacy team.</p>
            </div>
            <div className="service-card">
              <div className="service-icon">🏠</div>
              <h3>Home Delivery</h3>
              <p>Convenient home delivery service for medicines and health products across the city.</p>
            </div>
            <div className="service-card">
              <div className="service-icon">📋</div>
              <h3>Health Checkups</h3>
              <p>Basic health screening services including blood pressure, blood sugar, and BMI monitoring.</p>
            </div>
            <div className="service-card">
              <div className="service-icon">💉</div>
              <h3>Vaccination Services</h3>
              <p>Complete vaccination services for all age groups including flu shots and travel vaccines.</p>
            </div>
            <div className="service-card">
              <div className="service-icon">🔬</div>
              <h3>Lab Services</h3>
              <p>On-site laboratory services for quick diagnostic tests and health monitoring.</p>
            </div>
          </div>
        </div>
      </section>

      {/* About Section */}
      <section id="about" className="about">
        <div className="container">
          <div className="about-content">
            <div className="about-text">
              <h2>About HealthCare Pharmacy</h2>
              <p>With over 15 years of experience in pharmaceutical care, HealthCare Pharmacy has been serving the communities of Chennai and Bengaluru with dedication and excellence.</p>
              <div className="stats">
                <div className="stat">
                  <h3>50,000+</h3>
                  <p>Happy Customers</p>
                </div>
                <div className="stat">
                  <h3>15+</h3>
                  <p>Years Experience</p>
                </div>
                <div className="stat">
                  <h3>24/7</h3>
                  <p>Emergency Service</p>
                </div>
              </div>
            </div>
            <div className="about-features">
              <div className="feature">
                <h4>🎯 Quality Assurance</h4>
                <p>All medicines sourced directly from authorized distributors with proper storage conditions.</p>
              </div>
              <div className="feature">
                <h4>👨‍⚕️ Expert Team</h4>
                <p>Licensed pharmacists available for medication counseling and health advice.</p>
              </div>
              <div className="feature">
                <h4>🚀 Fast Service</h4>
                <p>Quick prescription processing and efficient home delivery within 2 hours.</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Locations Section */}
      <section className="locations">
        <div className="container">
          <h2>Our Locations</h2>
          <div className="locations-grid">
            <div className="location-card">
              <h3>Chennai Branches</h3>
              <div className="location-list">
                <div className="location-item">
                  <strong>Anna Nagar</strong>
                  <p>123 Main Road, Anna Nagar, Chennai - 600040</p>
                </div>
                <div className="location-item">
                  <strong>Adyar</strong>
                  <p>456 Adyar Main Road, Adyar, Chennai - 600020</p>
                </div>
                <div className="location-item">
                  <strong>T Nagar</strong>
                  <p>789 Pondy Bazaar, T Nagar, Chennai - 600017</p>
                </div>
              </div>
            </div>
            <div className="location-card">
              <h3>Bengaluru Branch</h3>
              <div className="location-list">
                <div className="location-item">
                  <strong>Jayanagar</strong>
                  <p>321 4th Block, Jayanagar, Bengaluru - 560069</p>
                  <p>📞 +91 88700 01377</p>
                </div>
              </div>
            </div>
          </div>
          <div className="hours">
            <h3>Operating Hours</h3>
            <p>Monday to Sunday: 10:00 AM - 8:00 PM</p>
            <p>Emergency Services: 24/7</p>
          </div>
        </div>
      </section>

      {/* Testimonials Section */}
      <section className="testimonials">
        <div className="container">
          <h2>What Our Customers Say</h2>
          <div className="testimonials-grid">
            <div className="testimonial-card">
              <div className="stars">⭐⭐⭐⭐⭐</div>
              <p>"Excellent service and very knowledgeable pharmacists. They always take time to explain medications properly."</p>
              <div className="customer">
                <strong>Priya S.</strong>
                <span>Chennai Customer</span>
              </div>
            </div>
            <div className="testimonial-card">
              <div className="stars">⭐⭐⭐⭐⭐</div>
              <p>"Fast home delivery and genuine medicines. Very reliable pharmacy with great customer service."</p>
              <div className="customer">
                <strong>Rajesh K.</strong>
                <span>Bengaluru Customer</span>
              </div>
            </div>
            <div className="testimonial-card">
              <div className="stars">⭐⭐⭐⭐⭐</div>
              <p>"The health consultation service is amazing. They helped me manage my medications better."</p>
              <div className="customer">
                <strong>Anitha M.</strong>
                <span>Chennai Customer</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Contact Section */}
      <section id="contact" className="contact">
        <div className="container">
          <h2>Contact Us</h2>
          <div className="contact-content">
            <div className="contact-info">
              <div className="contact-item">
                <h4>📞 Phone</h4>
                <p>+91 88700 01377</p>
              </div>
              <div className="contact-item">
                <h4>📧 Email</h4>
                <p>info@healthcarepharmacy.com</p>
              </div>
              <div className="contact-item">
                <h4>🕒 Hours</h4>
                <p>Mon-Sun: 10:00 AM - 8:00 PM</p>
              </div>
              <div className="contact-item">
                <h4>🚨 Emergency</h4>
                <p>24/7 Emergency Services Available</p>
              </div>
            </div>
            <div className="contact-form">
              <h3>Send us a Message</h3>
              <form>
                <input type="text" placeholder="Your Name" required />
                <input type="email" placeholder="Your Email" required />
                <input type="tel" placeholder="Your Phone" />
                <textarea placeholder="Your Message" rows="4" required></textarea>
                <button type="submit" className="btn-primary">Send Message</button>
              </form>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="footer">
        <div className="container">
          <div className="footer-content">
            <div className="footer-section">
              <h3>🏥 HealthCare Pharmacy</h3>
              <p>Your trusted partner in health and wellness, providing quality pharmaceutical care across Chennai and Bengaluru.</p>
            </div>
            <div className="footer-section">
              <h4>Quick Links</h4>
              <ul>
                <li><a href="#home">Home</a></li>
                <li><a href="#services">Services</a></li>
                <li><a href="#about">About</a></li>
                <li><a href="#contact">Contact</a></li>
              </ul>
            </div>
            <div className="footer-section">
              <h4>Services</h4>
              <ul>
                <li>Prescription Medicines</li>
                <li>Health Consultations</li>
                <li>Home Delivery</li>
                <li>Vaccination Services</li>
              </ul>
            </div>
            <div className="footer-section">
              <h4>Emergency Contact</h4>
              <p>📞 +91 88700 01377</p>
              <p>Available 24/7 for emergencies</p>
            </div>
          </div>
          <div className="footer-bottom">
            <p>&copy; 2025 HealthCare Pharmacy. All rights reserved.</p>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default App;
